import { createStore, stateSetterHandler } from '@alpha.apps/react-common';

import { StateSetter } from '../../types';
import { TimeDuration } from '../../services/movie-finder';
import { Filter } from '@/components/movie-finder/filters';

export type MovieFinderState = {
  searchText: string;
  selectedDate: string;
  selectedTimeDuration: string;
  selectedMovies: number[];
  selectedCinemas: number[];
  selectedExperiences: number[];
  isShowResults: boolean;
  selectedFilters: Filter[];
};

const initState: MovieFinderState = {
  searchText: '',
  selectedDate: '',
  selectedTimeDuration: TimeDuration.ALL_DAY,
  selectedMovies: [],
  selectedCinemas: [],
  selectedExperiences: [],
  isShowResults: false,
  selectedFilters: [],
};

export type MovieFinderProps = {
  setSearchText: StateSetter<string>;
  setSelectedDate: StateSetter<string>;
  setSelectedTimeDuration: StateSetter<string>;
  setSelectedMovies: StateSetter<number[]>;
  setSelectedCinemas: StateSetter<number[]>;
  setSelectedExperiences: StateSetter<number[]>;
  setIsShowResults: StateSetter<boolean>;
  setSelectedFilters: StateSetter<Filter[]>;
};

export const useMovieFinder = createStore({
  name: 'movie-finder-state',
  devtools: true,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setSearchText: handler('searchText'),
    setSelectedDate: handler('selectedDate'),
    setSelectedTimeDuration: handler('selectedTimeDuration'),
    setSelectedMovies: handler('selectedMovies'),
    setSelectedCinemas: handler('selectedCinemas'),
    setSelectedExperiences: handler('selectedExperiences'),
    setIsShowResults: handler('isShowResults'),
    setSelectedFilters: handler('selectedFilters'),
  } as MovieFinderProps;
});
